import React from 'react';

function SpreadsheetsIcon() {
  return (
    <svg
      width="75"
      height="101"
      viewBox="0 0 75 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.75 46.6405C16.427 46.6405 14.5833 48.5949 14.5833 50.8071V82.0571C14.5833 84.4222 16.385 86.2238 18.75 86.2238H56.25C58.4622 86.2238 60.4167 84.3801 60.4167 82.0571V50.8071C60.4167 48.6374 58.4197 46.6405 56.25 46.6405H18.75ZM10.4167 50.8071C10.4167 46.3787 14.0418 42.4738 18.75 42.4738H56.25C60.7209 42.4738 64.5833 46.3362 64.5833 50.8071V82.0571C64.5833 86.7654 60.6784 90.3905 56.25 90.3905H18.75C14.0838 90.3905 10.4167 86.7233 10.4167 82.0571V50.8071ZM16.6667 48.7238H58.3333V59.1405H16.6667V48.7238ZM20.8333 52.8905V54.9738H54.1667V52.8905H20.8333ZM16.6667 61.2238H36.4583V71.6405H16.6667V61.2238ZM20.8333 65.3905V67.4738H32.2917V65.3905H20.8333ZM38.5417 61.2238H58.3333V71.6405H38.5417V61.2238ZM42.7083 65.3905V67.4738H54.1667V65.3905H42.7083ZM16.6667 73.7238H36.4583V84.1405H16.6667V73.7238ZM20.8333 77.8905V79.9738H32.2917V77.8905H20.8333ZM38.5417 73.7238H58.3333V84.1405H38.5417V73.7238ZM42.7083 77.8905V79.9738H54.1667V77.8905H42.7083Z"
        fill="#C9C2F5"
      />
      <path
        d="M62.5 94.5571C65.8203 94.5571 68.75 91.8228 68.75 88.3071V38.3071H46.875C41.6016 38.3071 37.5 34.2056 37.5 28.9321V7.05713H12.5C8.98438 7.05713 6.25 9.98682 6.25 13.3071V88.3071C6.25 91.8228 8.98438 94.5571 12.5 94.5571H62.5ZM46.875 32.0571H68.5547C68.3594 31.6665 68.1641 31.0806 67.7734 30.6899L45.1172 8.03369C44.7266 7.64307 44.1406 7.44775 43.75 7.25244V28.9321C43.75 30.6899 45.1172 32.0571 46.875 32.0571ZM12.5 0.807129H42.9688C45.3125 0.807129 47.8516 1.979 49.6094 3.73682L72.0703 26.1978C73.8281 27.9556 75 30.4946 75 32.8384V88.3071C75 95.3384 69.3359 100.807 62.5 100.807H12.5C5.46875 100.807 0 95.3384 0 88.3071V13.3071C0 6.47119 5.46875 0.807129 12.5 0.807129Z"
        fill="#6754E2"
      />
    </svg>
  );
}
export default SpreadsheetsIcon;
